<template>
  <div class="page-content-wrap">
    <FileFullPreviewMode></FileFullPreviewMode>
    <!-- Alerts -->
    <div
      v-if="form.status === 'canceled' && form.canceled_comments"
      class="row row-alert"
    >
      <div class="col-12">
        <div
          class="alert alert-danger alert-content"
          v-html="form.canceled_comments"
        ></div>
      </div>
    </div>

    <div
      v-if="form.status === 'revise' && form.revise_comments"
      class="row row-alert"
    >
      <div class="col-12">
        <div
          class="alert alert-warning alert-content"
          v-html="form.revise_comments"
        ></div>
      </div>
    </div>

    <!-- Form -->
    <form
      id="serviceRegistration"
      class="service-register-form"
      @submit="serviceRegistration"
    >
      <input type="hidden" name="service_id" :value="form.id" />

      <!-- Status -->
      <div
        v-if="form.locked || (!form.locked && form.status === 'revise')"
        class="row row-service"
      >
        <div class="col-4 col-name">Statusas</div>
        <div class="col-8 col-value">
          <span :class="['badge', 'badge-' + effectiveStatus]">
            {{ $t('services.status.' + effectiveStatus) }}
          </span>
        </div>
      </div>

      <!-- Dynamic attributes -->
      <div
        v-for="(attribute, index) in form.form_structure"
        :key="index"
        class="row row-service"
      >
        <!-- Names -->
        <div
          v-if="attribute.type === 'service_form_fullname'"
          class="col-xs-12 col-md-4 col-name"
        >
          Pareiškėjas
        </div>
        <div
          v-if="attribute.type === 'service_form_email'"
          class="col-xs-12 col-md-4 col-name"
        >
          El. pašto adresas
        </div>
        <div
          v-if="attribute.type === 'service_form_price'"
          class="col-xs-12 col-md-4 col-name"
        >
          Mokama suma
        </div>

        <!-- Generic name -->
        <div
          v-if="isGenericField(attribute) && attribute.kind !== 'form_data'"
          class="col-xs-12 col-md-4 col-name"
        >
          {{ attribute.name[$app.lang] }}
        </div>

        <!-- Values -->
        <div
          v-if="attribute.type === 'service_form_fullname'"
          class="col-8 col-value"
        >
          {{ form.user_name }} {{ form.user_surname }}
        </div>

        <div
          v-if="attribute.type === 'service_form_email'"
          class="col-8 col-value"
        >
          {{ form.user_email }}
        </div>

        <div
          v-if="attribute.type === 'service_form_price'"
          class="col-8 col-value"
        >
          <template v-if="form.form_data[attribute.identifier]">
            {{ form.form_data[attribute.identifier] }} EUR
          </template>
        </div>

        <div
          v-if="isGenericField(attribute) && attribute.kind !== 'form_data'"
          class="col-8 col-value"
        >
          <template v-if="hasValue(attribute)">
            <template
              v-if="attribute.type === 'select' || attribute.type === 'radio'"
            >
              {{
                optionNameById(
                  attribute.options,
                  form.form_data[attribute.identifier],
                )
              }}
            </template>

            <template v-else-if="attribute.type === 'checkbox'">
              <div
                v-for="(checkValue, cK) in selectedCheckBoxOptions(
                  attribute.options,
                  form.form_data[attribute.identifier],
                )"
                :key="cK"
              >
                {{ checkValue }}
              </div>
            </template>

            <template v-else-if="attribute.type === 'toggle'">
              {{ toggleLabelByValue(form.form_data[attribute.identifier]) }}
            </template>

            <template v-else-if="attribute.type === 'email'">
              <a
                :href="`mailto:${form.form_data[attribute.identifier]}`"
                class="service-link"
              >
                {{ form.form_data[attribute.identifier] }}
              </a>
            </template>

            <template v-else-if="attribute.type === 'wysiwyg'">
              <div v-html="form.form_data[attribute.identifier]"></div>
            </template>

            <template v-else-if="attribute.type === 'upload'">
              <file-preview
                :folder="valueOf(attribute)"
                :show-file-name="
                  attribute.show_file_name != null
                    ? attribute.show_file_name
                    : 1
                "
                :show-file-size="
                  attribute.show_file_size != null
                    ? attribute.show_file_size
                    : 1
                "
                :show-file-extension="
                  attribute.show_file_extension != null
                    ? attribute.show_file_extension
                    : 1
                "
              />
            </template>

            <template v-else>
              {{ form.form_data[attribute.identifier] }}
            </template>
          </template>

          <template v-else>
            <template v-if="attribute.type === 'toggle'">
              {{ toggleLabelByValue(form.form_data[attribute.identifier]) }}
            </template>
            <template v-else> - </template>
          </template>
        </div>
      </div>

      <!-- Price row -->
      <div
        v-if="form.paid_service && !form.user_price_enabled"
        class="row row-service"
      >
        <div class="col-xs-12 col-md-4 col-name">Kaina</div>
        <div v-if="service.price > 0" class="col-8 col-value">
          {{ service.price / 100 }} EUR
        </div>
        <div v-else class="col-8 col-value">Nemokamai</div>
      </div>

      <!-- Actions (unlocked & not revise) -->
      <div
        v-if="!form.locked && form.status !== 'revise'"
        class="row row-service"
      >
        <div class="col-xs-12 col-md-4 col-name"></div>
        <div class="col-xs-12 col-md-8 col-value">
          <a
            href="/account/dashboard"
            class="btn btn-primary blue-light-fill-in mr-2 action-btn-set"
          >
            <i class="fas fa-chevron-left"></i> Mano užsakymai
          </a>

          <a
            :href="`/account/services/${form.id}/edit`"
            class="btn btn-warning blue mr-2 action-btn-set"
          >
            <i class="fas fa-pencil-alt"></i> Koreguoti
          </a>

          <template v-if="form.paid_service && form.prepaid">
            <button
              v-if="form.paid_service"
              class="btn btn-primary greene-light-fill-in mr-2 action-btn-set"
              type="button"
              @click="addServiceToCartPay"
            >
              <i class="fas fa-cart-plus"></i> Užsakyti / Apmokėti
            </button>
          </template>

          <template v-if="!form.prepaid">
            <button
              v-if="pending"
              class="btn btn-primary greene-light-fill-in mr-2 action-btn-set"
              type="button"
            >
              <i class="fas fa-receipt"></i> Prašome palaukti
            </button>
            <button
              v-else
              class="btn btn-primary greene-light-fill-in mr-2 action-btn-set"
              type="submit"
            >
              <i class="fas fa-receipt"></i> Užsakyti
            </button>
          </template>
        </div>
      </div>

      <!-- Actions (locked) -->
      <div v-if="form.locked" class="row row-service">
        <div class="col-xs-12 col-md-4 col-name"></div>
        <div class="col-xs-12 col-md-8 col-value">
          <a
            href="/account/dashboard"
            class="btn btn-primary blue-light-fill-in mr-2 action-btn-set"
          >
            <i class="fas fa-chevron-left"></i> Mano užsakymai
          </a>

          <template
            v-if="form.paid_service && form.init_pay && !form.payment_received"
          >
            <button
              class="btn btn-primary greene-light-fill-in action-btn-set"
              type="button"
              @click="addServiceToCartPay"
            >
              <i class="fas fa-cart-plus"></i> Užsakyti / Apmokėti
            </button>
          </template>
        </div>
      </div>

      <!-- Actions (revise) -->
      <div
        v-if="!form.locked && form.status === 'revise'"
        class="row row-service"
      >
        <div class="col-xs-12 col-md-4 col-name"></div>
        <div class="col-xs-12 col-md-8 col-value">
          <a
            href="/account/dashboard"
            class="btn btn-primary blue-light-fill-in mr-2 action-btn-set"
          >
            <i class="fas fa-chevron-left"></i> Mano užsakymai
          </a>
          <a
            :href="`/account/services/${form.id}/edit`"
            class="btn btn-warning blue mr-2 action-btn-set"
          >
            <i class="fas fa-pencil-alt"></i> Koreguoti
          </a>

          <template v-if="!form.prepaid">
            <button
              v-if="pending"
              class="btn btn-primary greene-light-fill-in mr-2 action-btn-set"
              type="button"
            >
              <i class="fas fa-receipt"></i> Prašome palaukti
            </button>
            <button
              v-else
              class="btn btn-primary greene-light-fill-in action-btn-set"
              type="submit"
            >
              <i class="fas fa-receipt"></i> Užsakyti
            </button>
          </template>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import form from '@core/js/mixins/form'
import _ from 'lodash'
import axios from 'axios'
import FilePreview from '@assets/js/views/Preview/FilePreview'
import FileFullPreviewMode from '@assets/js/components/Preview/FileFullPreviewMode'

export default {
  name: 'ServiceRegistration',
  components: {
    FilePreview,
    FileFullPreviewMode,
  },
  mixins: [form],
  props: {
    service: { type: Object, default: () => ({}) },
    form: { type: Object, default: () => ({}) },
  },
  data() {
    return { pending: false }
  },
  computed: {
    // If init_pay is true and not received, status is payment_pending, else real status
    effectiveStatus() {
      if (this.form?.init_pay && !this.form?.payment_received) {
        return 'payment_pending'
      }
      return this.form?.status || 'unknown'
    },
  },
  methods: {
    valueOf(attr) {
      if (!attr?.identifier) return undefined
      return this.form?.form_data?.[attr.identifier]
    },
    isGenericField(attr) {
      if (!attr) return false
      const types = [
        'text',
        'email',
        'textarea',
        'wysiwyg',
        'number',
        'toggle',
        'select',
        'radio',
        'checkbox',
        'upload',
        'file',
        'image',
      ]
      return types.includes(attr.type)
    },
    hasValue(attr) {
      const v = this.form?.form_data?.[attr.identifier]
      return (
        v !== undefined && v !== null && !(Array.isArray(v) && v.length === 0)
      )
    },
    addServiceToCart() {
      this.$store.dispatch('basket/addToBasket', {
        record_type: 'record',
        record_id: this.form.fid,
        code: this.service.sid,
        name: this.form.name,
        quantity: 1,
        price: this.form.price,
        line_total: 1,
      })
      this.$emit('close')
    },
    addServiceToCartPay() {
      this.$store.dispatch('basket/addToBasket', {
        record_type: 'record_pay',
        record_id: this.form.fid,
        code: this.service.sid,
        name: this.form.name,
        quantity: 1,
        price: this.form.price,
        line_total: 1,
      })
      this.$emit('close')
    },
    optionNameById(options, identifier) {
      if (!options) return ''
      const found = _.find(options, { id: identifier })
      return found ? found.text : ''
    },
    selectedCheckBoxOptions(options, identifiers) {
      if (!options || !Array.isArray(identifiers)) return []
      return identifiers
        .map((id) => _.find(options, { id }))
        .filter(Boolean)
        .map((opt) => opt.text)
    },
    toggleLabelByValue(value) {
      return value ? 'Taip' : 'Ne'
    },

    async serviceRegistration(e) {
      e.preventDefault()
      if (this.pending) return
      this.pending = true

      try {
        // Build body like jQuery .serialize() but without jQuery
        const formEl = this.$el.querySelector('#serviceRegistration')
        const body = new URLSearchParams(new FormData(formEl)) // <-- urlencoded payload

        const { data } = await axios.post(
          `/account/services/${this.form.id}/submit-request`,
          body,
        )

        this.pending = false

        if (data?.status === 'success') {
          this.$nextTick(() => {
            window.location.href = '/account/dashboard'
          })
        }
      } catch (error) {
        this.pending = false
        // You can surface a toast or log if you have a helper:
        // this.$app?.error?.(error)
      }
    },

    statusRender(status) {
      // kept for compatibility if you still call it somewhere else
      return (
        '<span class="badge badge-' +
        status +
        '">' +
        this.$t('services.status.' + status) +
        '<span>'
      )
    },
  },
}
</script>
